export default "__VITE_ASSET__DCSlZmaE__"